// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ge-0";